export const GAME_STATUS = {
  PUBLISHED: "PUBLISHED",
  CANCELLED: "CANCELLED",
  COMPLETED: "COMPLETED",
};

export const GAME_VISIBILITY = {
  PUBLIC: "PUBLIC",
  PRIVATE: "PRIVATE",
};

export const GAME_INVITATION_FREQUENCY = {
  NO_INVITE: "NO_INVITE",
  "1_DAYS_BEFORE": "1_DAY",
  "2_DAYS_BEFORE": "2_DAYS",
  "3_DAYS_BEFORE": "3_DAYS",
  "4_DAYS_BEFORE": "4_DAYS",
};

export const GAME_PAYMENT_MODE = {
  IN_APP: "IN_APP",
  SELF: "SELF",
};

export const SPORTS = [
  "Football",
  "Basketball",
  "Volleyball",
  "Ultimate Frisbee",
  "Tag Rugby",
  "Softball",
  "Baseball",
  "Handball",
  "Cricket",
  "American Football",
];

export const PLAYERS_TEAM_SIZE = {
  ONE_V_ONE: "2_1_V_1",
  TWO_V_TWO: "4_2_V_2",
  THREE_V_THREE: "6_3_V_3",
  FOUR_V_FOUR: "8_4_V_4",
  FIVE_V_FIVE: "10_5_V_5",
  SIX_V_SIX: "12_6_V_6",
  SEVEN_V_SEVEN: "14_7_V_7",
  EIGHT_V_EIGHT: "16_8_V_8",
  NINE_V_NINE: "18_9_V_9",
  TEN_V_TEN: "20_10_V_10",
  ELEVEN_V_ELEVEN: "22_11_V_11",
  TWELVE_V_TWELVE: "24_12_V_12",
  THIRTEEN_V_THIRTEEN: "26_13_V_13",
  FOURTEEN_V_FOURTEEN: "28_14_V_14",
  FIFTEEN_V_FIFTEEN: "30_15_V_15",
};

export const GAME_DURATION_OPTIONS = [30, 45, 60, 75, 90, 120];

export const PLAYER_ROLES = {
  HOST: "HOST",
  PLAYER: "PLAYER",
};

export const INVITE_STATUS = {
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
  DECLINED: "DECLINED",
};
